<template>
  <div class="media-gallery">
    <div class="items">
      <media-gallery-item
        v-for="item, index in media"
        v-if="index == currentIndex"
        :key="item.id"
        :item="item"
      ></media-gallery-item>
    </div>

    <div class="thumbnails">
      <media-gallery-thumbnail
        v-for="item, index in media"
        :key="item.id"
        :item="item"
        @click.native="selectItem(index)"
        class="thumbnail"
        :class="{ active: index == currentIndex }"
      ></media-gallery-thumbnail>
    </div>
  </div>
</template>

<script>

import MediaGalleryItem from '@/components/MediaGalleryItem';
import MediaGalleryThumbnail from '@/components/MediaGalleryThumbnail';

export default {
  name: 'MediaGallery',
  components: {
    MediaGalleryItem,
    MediaGalleryThumbnail,
  },
  props: {
    media: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      currentIndex: 0,
    };
  },
  methods: {
    selectItem(index) {
      this.currentIndex = index;
    },
  },
};

</script>

<style scoped>

.thumbnails {
  margin-top: 30px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.thumbnail {
  margin-right: 20px;
  margin-bottom: 20px;
  cursor: pointer;
  position: relative;
}

.thumbnail.active:before {
  content: '';
  display: block;
  position: absolute;
  top: -10px;
  left: -10px;
  right: -10px;
  bottom: -10px;
  /*background-image: linear-gradient(45deg, #16a83a 16.67%, #F6F0CF 16.67%, #F6F0CF 50%, #16a83a 50%, #16a83a 66.67%, #F6F0CF 66.67%, #F6F0CF 100%);*/
  /*background-size: 8.49px 8.49px;*/
  /*background-image: linear-gradient(45deg, #16a83a 8.33%, #F6F0CF 8.33%, #F6F0CF 50%, #16a83a 50%, #16a83a 58.33%, #F6F0CF 58.33%, #F6F0CF 100%);*/
  /*background-size: 8.49px 8.49px;*/
  /*background-image: linear-gradient(45deg, #52b56a 16.67%, #fcfcfc 16.67%, #fcfcfc 50%, #52b56a 50%, #52b56a 66.67%, #fcfcfc 66.67%, #fcfcfc 100%);
  background-size: 8.49px 8.49px;*/
  background-image: linear-gradient(45deg, #88a088 16.67%, #fcfcfc 16.67%, #fcfcfc 50%, #88a088 50%, #88a088 66.67%, #fcfcfc 66.67%, #fcfcfc 100%);
  background-size: 8.49px 8.49px;
  background-position-x: -1px;
  background-position-y: 1px;
  /*background-image: linear-gradient(45deg, #5d8066 12.50%, #fcfcfc 12.50%, #fcfcfc 50%, #5d8066 50%, #5d8066 62.50%, #fcfcfc 62.50%, #fcfcfc 100%);
  background-size: 5.66px 5.66px;*/
  /*background-image: linear-gradient(45deg, #9fb5a4 16.67%, #fcfcfc 16.67%, #fcfcfc 50%, #9fb5a4 50%, #9fb5a4 66.67%, #fcfcfc 66.67%, #fcfcfc 100%);
  background-size: 6.00px 6.00px;*/
  /*background-image: linear-gradient(45deg, #98b39f 16.67%, #fcfcfc 16.67%, #fcfcfc 50%, #98b39f 50%, #98b39f 66.67%, #fcfcfc 66.67%, #fcfcfc 100%);
  background-size: 6.00px 6.00px;*/
}

/*.thumbnail.active {
  opacity: 0.3;
  cursor: auto;
}*/

/*.thumbnail * {
  opacity: 0.9;
}*/

</style>



// WEBPACK FOOTER //
// src/components/MediaGallery.vue